import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { DEFAULT_BANNER_SIZE } from 'common/entities/form/styleConfiguration/defaultValues';
import { NONE_TYPE, BANNER_TYPE } from 'common/entities/form/styleConfiguration/constants';

import { getFormHeaderImageStyles } from 'common/entities/form/styleConfiguration/selectors';
import { withFormId } from '../FormIdContext';

const BannerImage = styled.div`
    padding-bottom: ${DEFAULT_BANNER_SIZE}rem;
    width: 100%;
    background-image: ${(props) => (props.imageUrl ? `url("${props.imageUrl}")` : 'none')};
    background-size: cover;
    background-position: center center;

    @media (max-width: 667px) {
        padding-bottom: 8rem;
    }
`;

const BASE_COMPONENT_NAME = 'FormBanner';

const FormBanner = ({ imageUrl, imageType, imageAltText }) =>
    imageType === BANNER_TYPE && imageUrl ? (
        <BannerImage data-qa={`${BASE_COMPONENT_NAME}__container`} imageUrl={imageUrl}>
            {imageAltText && <span role="img" aria-label={imageAltText} />}
        </BannerImage>
    ) : null;

FormBanner.propTypes = {
    imageUrl: PropTypes.string,
    imageAltText: PropTypes.string,
    imageType: PropTypes.string.isRequired,
};

FormBanner.defaultProps = {
    imageUrl: null,
    imageAltText: null,
};

const mapStateToProps = (state, props) => {
    const { formId } = props;
    const {
        url: imageUrl,
        type: imageType = NONE_TYPE,
        altText: imageAltText,
    } = getFormHeaderImageStyles(state, formId);

    return {
        imageUrl,
        imageType,
        imageAltText,
    };
};

const mapDispatchToProps = {};

export default withFormId(connect(mapStateToProps, mapDispatchToProps)(FormBanner));
